export const PARTY_PASS_UPSELL_EXPANDED_STORAGE_PREFIX =
  "party-pass-upsell-expanded";
export const PARTY_PASS_UPSELL_EXPANDED_VALUE = "1";
export const PARTY_PASS_UPSELL_EXPAND_QUERY_VALUE = "party-pass";

export interface PartyPassUpsellStorageReader {
  getItem(key: string): string | null;
}

export interface PartyPassUpsellStorageWriter {
  setItem(key: string, value: string): void;
  removeItem(key: string): void;
}

function normalizePartyId(partyId: string): string {
  return partyId.trim();
}

export function getPartyPassUpsellExpandedStorageKey(partyId: string): string {
  return `${PARTY_PASS_UPSELL_EXPANDED_STORAGE_PREFIX}:${normalizePartyId(partyId)}`;
}

export function isPartyPassUpsellExpanded(
  storage: PartyPassUpsellStorageReader,
  partyId: string,
): boolean {
  const normalized = normalizePartyId(partyId);
  if (!normalized) {
    return false;
  }

  return (
    storage.getItem(getPartyPassUpsellExpandedStorageKey(normalized)) ===
    PARTY_PASS_UPSELL_EXPANDED_VALUE
  );
}

export function setPartyPassUpsellExpanded(
  storage: PartyPassUpsellStorageWriter,
  partyId: string,
  expanded: boolean,
): void {
  const normalized = normalizePartyId(partyId);
  if (!normalized) {
    return;
  }

  const key = getPartyPassUpsellExpandedStorageKey(normalized);
  if (expanded) {
    storage.setItem(key, PARTY_PASS_UPSELL_EXPANDED_VALUE);
    return;
  }

  storage.removeItem(key);
}

export function isPartyPassUpsellExpandRequested(
  upgrade: string | null | undefined,
): boolean {
  if (!upgrade) {
    return false;
  }

  const normalized = upgrade.startsWith("#") ? upgrade.slice(1) : upgrade;
  return normalized === PARTY_PASS_UPSELL_EXPAND_QUERY_VALUE;
}

export function getPartyPassSettingsUpgradePath(partyId: string): string {
  const normalized = normalizePartyId(partyId);
  return `/parties/${normalized}/settings?upgrade=${PARTY_PASS_UPSELL_EXPAND_QUERY_VALUE}`;
}
